import { render, staticRenderFns } from "./BoardPerformanceReport.vue?vue&type=template&id=7238abf8"
import script from "./BoardPerformanceReport.vue?vue&type=script&lang=js"
export * from "./BoardPerformanceReport.vue?vue&type=script&lang=js"
import style0 from "./BoardPerformanceReport.vue?vue&type=style&index=0&id=7238abf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports